"use client";

import styles from "@/styles/modules/components/splash.module.scss";
import Image from "next/image";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { GallerySliderItem } from "@/types/wordpress-parts";
import "swiper/css";
import "swiper/css/autoplay";

interface SplashProps {
  slider: GallerySliderItem[];
}

export default function Splash({ slider }: SplashProps) {
  return (
    <section className={`gSplashContainer ${styles.splash}`} data-aos="fade-in">
      <Swiper
        modules={[Autoplay]}
        autoplay
        speed={300}
        loop={slider.length > 1 ? true : false}
        slidesPerView={1}
      >
        {slider!.map((image, i) => (
          <SwiperSlide key={i}>
            {image.imageOrVideo[0] === "Image" && (
              <Image
                alt={slider[i].image!.node.altText || "Imperial Riding School"}
                src={slider[i].image!.node.link}
                width={slider[i].image!.node.mediaDetails.width}
                height={slider[i].image!.node.mediaDetails.height}
              />
            )}
            {image.imageOrVideo[0] === "Video" && (
              <video autoPlay muted loop>
                <source src={image.video!} type="video/mp4" />
              </video>
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}
